import React from 'react';

export default () => (
  <div style={{ paddingTop: '100px', textAlign: 'center' }}>
    <h3>Sorry, page not found!</h3>
  </div>
);
